import { SIGN_UP_MODAL_PAGES } from '../constants/sign-up-modal.constants';

export const isBackButtonShowable = (
  currentStep: keyof typeof SIGN_UP_MODAL_PAGES,
) =>
  currentStep !== SIGN_UP_MODAL_PAGES.ACCEPT_PRIVACY_POLICY &&
  currentStep !== SIGN_UP_MODAL_PAGES.WEARABLES_CONNECTION &&
  currentStep !== SIGN_UP_MODAL_PAGES.SIGN_UP_SUCCESS;
